import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  bicOrSwift: () => __(translations.commercialDocumentFiscalInfoSection.bicOrSwift, 'BIC/Swift:'),
  iban: () => __(translations.commercialDocumentFiscalInfoSection.iban, 'IBAN:'),
};
